<script lang="ts">
  import { coarsePointer } from '../lib/stores/viewport';

  interface Props {
    title: string;
    description: string;
    visible: boolean;
    /** Where to position relative to the parent element */
    position?: 'below' | 'left' | 'below-left';
  }

  let { title, description, visible, position = 'below' }: Props = $props();
</script>

<!-- Hover-only: never on touch, where it would open on a tap and get stuck. -->
{#if visible && !$coarsePointer}
  <div class="nav-tooltip {position}" role="tooltip">
    <div class="tooltip-title">{title}</div>
    <div class="tooltip-desc">{description}</div>
  </div>
{/if}

<style>
  .nav-tooltip {
    position: absolute;
    width: 14rem;
    padding: 0.5rem 0.625rem;
    background: #1f2937;
    color: white;
    border-radius: 0.375rem;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    z-index: 100;
    pointer-events: none;
  }

  /* Position: below (default, used for navbar buttons) */
  .nav-tooltip.below {
    top: calc(100% + 0.5rem);
    left: 50%;
    transform: translateX(-50%);
    animation: fadeInBelow 0.15s ease;
  }

  /* Position: left (used for dropdown menu items) */
  .nav-tooltip.left {
    right: calc(100% + 0.5rem);
    top: 50%;
    transform: translateY(-50%);
    animation: fadeInLeft 0.15s ease;
  }

  /* Position: below-left (to the left of element, top-aligned so it doesn't clip above viewport) */
  .nav-tooltip.below-left {
    right: calc(100% + 0.5rem);
    top: 0;
    animation: fadeInBelowLeft 0.15s ease;
  }

  .tooltip-title {
    font-size: 0.6875rem;
    font-weight: 600;
    margin-bottom: 0.25rem;
  }

  .tooltip-desc {
    font-size: 0.625rem;
    line-height: 1.4;
    color: #d1d5db;
  }

  @keyframes fadeInBelow {
    from {
      opacity: 0;
      transform: translateX(-50%) translateY(-2px);
    }
    to {
      opacity: 1;
      transform: translateX(-50%) translateY(0);
    }
  }

  @keyframes fadeInBelowLeft {
    from {
      opacity: 0;
      transform: translateY(-2px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes fadeInLeft {
    from {
      opacity: 0;
      transform: translateY(-50%) translateX(4px);
    }
    to {
      opacity: 1;
      transform: translateY(-50%) translateX(0);
    }
  }
</style>
